import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ExcelMassiveUploadServices from "./ExcelMassiveUpload.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const saveExcelMassiveUpload =
  (req, setExcelData, item) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_EXCEL_MASSIVE_UPLOAD,
        payload: true,
      });
      const resp = await ExcelMassiveUploadServices.saveExcelMassiveUpload(req);
      dispatch({
        type: actions.EXCEL_MASSIVE_UPLOAD_PROBLEMS,
        payload: resp.data.problemas,
      });
      dispatch({
        type: actions.EXCEL_MASSIVE_UPLOAD_FAIL,
        payload: "",
      });
      setExcelData(null);
      item.archivo_excel = "";
      toastr.success(messages.fileSuccessMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.EXCEL_MASSIVE_UPLOAD_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_EXCEL_MASSIVE_UPLOAD,
        payload: false,
      });
    }
  };

export const resetExcelMassiveUploadError = () => async (dispatch) => {
  dispatch({
    type: actions.EXCEL_MASSIVE_UPLOAD_PROBLEMS,
    payload: [],
  });
  dispatch({
    type: actions.EXCEL_MASSIVE_UPLOAD_FAIL,
    payload: "",
  });
};
